import React from "react";
import { Table, FormGroup, Label, Input, Button } from "reactstrap";
import Select from "react-select";

const ManageMaterialItems = ({
  materialItems,
  setCurrentTab,
  onEdit,
  onDelete,
  onAddNew,
  materials = [],
  currentMaterialItem,
  setCurrentMaterialItem,
  onSave,
  onCancel,
}) => {
  const isEditing = currentMaterialItem !== null && currentMaterialItem !== undefined;

  const isFormValid = () => {
    return (
      currentMaterialItem?.material_id &&
      currentMaterialItem?.price !== "" &&
      !isNaN(currentMaterialItem?.price) &&
      parseFloat(currentMaterialItem?.price) >= 0 &&
      currentMaterialItem?.quantity !== "" &&
      !isNaN(currentMaterialItem?.quantity) &&
      parseInt(currentMaterialItem?.quantity) > 0
    );
  };

  return (
    <>
      <style>{`
        .table-row-hover:hover {
          background-color: #e9ecef !important;
        }
        .table-row-hover:hover td {
          background-color: #e9ecef !important;
        }
        #material {
          width: 100% !important;
        }
        #material option {
          max-width: 50%;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
      <div style={{ width: "100%", padding: "0 1rem" }} className="mt-3">
      {materialItems.length > 0 ? (
        <div style={{ width: "100%", overflowX: "auto", marginBottom: "1.5rem" }}>
          <Table
            bordered
            responsive
            size="sm"
            className="mb-0 bg-light-grey"
            style={{ width: "100%" }}
          >
            <thead className="bg-secondary text-white">
              <tr>
                <th className="bg-secondary text-white fw-bold" style={{ padding: "0.75rem" }}>Material</th>
                <th className="bg-secondary text-white fw-bold" style={{ padding: "0.75rem", width: "120px" }}>Quantity</th>
                <th className="bg-secondary text-white fw-bold" style={{ padding: "0.75rem" }}>Price</th>
                <th className="bg-secondary text-white fw-bold" style={{ padding: "0.75rem" }}>Total Price</th>
                <th className="bg-secondary text-white fw-bold" style={{ padding: "0.75rem" }}>Actions</th>
              </tr>
            </thead>
            <tbody className="bg-light-grey">
              {materialItems.map((item) => {
                const isEditingThisItem = currentMaterialItem?.id === item.id;
                return (
                  <tr key={item.id} className="bg-light-grey table-row-hover">
                    <td className="bg-light-grey" style={{ padding: "0.75rem" }}>
                      {item.material?.name || "Material"}
                    </td>
                    <td className="bg-light-grey" style={{ padding: "0.75rem", width: "120px" }}>
                      {isEditingThisItem ? (
                        <div className="d-flex align-items-center column-gap-1" style={{ width: "100%" }}>
                          <Input
                            type="number"
                            min="1"
                            step="1"
                            value={currentMaterialItem?.quantity || ""}
                            style={{ width: "70px", flexShrink: 0 }}
                            onChange={(e) =>
                              setCurrentMaterialItem({
                                ...currentMaterialItem,
                                quantity: e.target.value,
                              })
                            }
                          />
                          <span style={{ flexShrink: 0 }}>{item.material?.unit || ""}</span>
                        </div>
                      ) : (
                        `${item.quantity} ${item.material?.unit || ""}`
                      )}
                    </td>
                    <td className="bg-light-grey" style={{ padding: "0.75rem" }}>
                      ₹{Number(item.price || 0).toLocaleString("en-IN")}
                    </td>
                    <td className="bg-light-grey" style={{ padding: "0.75rem" }}>
                      ₹{Number(item.total_price || 0).toLocaleString("en-IN")}
                    </td>
                    <td className="bg-light-grey" style={{ padding: "0.75rem" }}>
                      {isEditingThisItem ? (
                        <div className="d-flex align-items-center column-gap-2">
                          <button
                            onClick={onSave}
                            disabled={!isFormValid()}
                            className="btn btn-sm p-0 d-flex align-items-center justify-content-center"
                            style={{
                              width: "28px",
                              height: "28px",
                              backgroundColor: isFormValid() ? "#28a745" : "#6c757d",
                              border: "none",
                              borderRadius: "4px",
                              cursor: isFormValid() ? "pointer" : "not-allowed",
                              transition: "opacity 0.2s"
                            }}
                            onMouseEnter={(e) => isFormValid() && (e.target.style.opacity = "0.8")}
                            onMouseLeave={(e) => e.target.style.opacity = "1"}
                            title="Save"
                          >
                            <i className="fa-solid fa-check text-white" style={{ fontSize: "12px" }}></i>
                          </button>
                          <button
                            onClick={onCancel}
                            className="btn btn-sm p-0 d-flex align-items-center justify-content-center"
                            style={{
                              width: "28px",
                              height: "28px",
                              backgroundColor: "#6c757d",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              transition: "opacity 0.2s"
                            }}
                            onMouseEnter={(e) => e.target.style.opacity = "0.8"}
                            onMouseLeave={(e) => e.target.style.opacity = "1"}
                            title="Cancel"
                          >
                            <i className="fa-solid fa-times text-white" style={{ fontSize: "12px" }}></i>
                          </button>
                        </div>
                      ) : (
                        <div className="d-flex align-items-center column-gap-2">
                          <button
                            onClick={() => onEdit(item)}
                            className="btn btn-sm p-0 d-flex align-items-center justify-content-center"
                            style={{
                              width: "28px",
                              height: "28px",
                              backgroundColor: "#0d6efd",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              transition: "opacity 0.2s"
                            }}
                            onMouseEnter={(e) => e.target.style.opacity = "0.8"}
                            onMouseLeave={(e) => e.target.style.opacity = "1"}
                            title="Edit"
                          >
                            <i className="fa-solid fa-pencil text-white" style={{ fontSize: "12px" }}></i>
                          </button>
                          <button
                            onClick={() => onDelete(item)}
                            className="btn btn-sm p-0 d-flex align-items-center justify-content-center"
                            style={{
                              width: "28px",
                              height: "28px",
                              backgroundColor: "#dc3545",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                              transition: "opacity 0.2s"
                            }}
                            onMouseEnter={(e) => e.target.style.opacity = "0.8"}
                            onMouseLeave={(e) => e.target.style.opacity = "1"}
                            title="Delete"
                          >
                            <i className="fa-solid fa-trash text-white" style={{ fontSize: "12px" }}></i>
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="text-center py-5 text-muted">
          <i className="fa-solid fa-box-open fs-4 mb-2 d-block" style={{ opacity: 0.5 }}></i>
          <p className="mb-0">No material items</p>
        </div>
      )}

      {isEditing && !currentMaterialItem?.id ? (
        <div className="p-3 mb-2 border rounded" style={{ backgroundColor: "#f8f9fa" }}>
          <FormGroup className="mb-2" style={{ maxWidth: "100%" }}>
            <Label for="material" className="fw-semibold mb-1">Material</Label>
            <Select
              value={
                currentMaterialItem?.material_id
                  ? materials
                      .map((material) => ({
                        label: material.name,
                        value: material.id,
                      }))
                      .find((opt) => opt.value === parseInt(currentMaterialItem.material_id))
                  : null
              }
              options={materials.map((material) => ({
                label: material.name,
                value: material.id,
              }))}
              onChange={(option) => {
                const selectedMaterialId = option ? option.value.toString() : "";
                const selectedMaterial = materials.find(
                  (m) => m.id === parseInt(selectedMaterialId)
                );
                setCurrentMaterialItem({
                  ...currentMaterialItem,
                  material_id: selectedMaterialId,
                  price:
                    selectedMaterial?.cost_price !== undefined &&
                    selectedMaterial?.cost_price !== null
                      ? selectedMaterial.cost_price.toString()
                      : currentMaterialItem?.price || "",
                });
              }}
              placeholder="Select Material"
              isClearable
              className="react-select-container"
              classNamePrefix="react-select"
            />
          </FormGroup>

          <div className="d-flex column-gap-3 align-items-end mb-2 pb-2">
            <div style={{ width: "120px", minWidth: "120px" }} className="mb-0">
              <Label className="fw-semibold mb-1 d-block">Price</Label>
              <div className="d-flex align-items-center" style={{ height: "38px", padding: "0.375rem 0.75rem", backgroundColor: "#e9ecef", borderRadius: "0.25rem", border: "1px solid #ced4da" }}>
                <span className="text-muted">
                  {currentMaterialItem?.material_id ? (
                    (() => {
                      const selectedMaterial = materials.find(
                        (m) => m.id === parseInt(currentMaterialItem?.material_id)
                      );
                      return selectedMaterial?.cost_price !== undefined &&
                        selectedMaterial?.cost_price !== null
                        ? `₹${Number(selectedMaterial.cost_price).toLocaleString("en-IN")}`
                        : "—";
                    })()
                  ) : (
                    "—"
                  )}
                </span>
              </div>
            </div>

            <div style={{ width: "120px", minWidth: "120px" }} className="mb-0">
              <Label for="quantity" className="fw-semibold mb-1 d-block">Quantity</Label>
              <Input
                id="quantity"
                type="number"
                min="1"
                step="1"
                value={currentMaterialItem?.quantity || ""}
                onChange={(e) =>
                  setCurrentMaterialItem({
                    ...currentMaterialItem,
                    quantity: e.target.value,
                  })
                }
                style={{ height: "38px", backgroundColor: "#ffffff", borderRadius: "0.25rem", border: "1px solid #ced4da" }}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end column-gap-2 pt-3 border-top" style={{ marginLeft: "-1rem", marginRight: "-1rem", paddingLeft: "1rem", paddingRight: "1rem" }}>
            <Button
              color="primary"
              onClick={onSave}
              disabled={!isFormValid()}
              size="sm"
            >
              Add
            </Button>
            <Button color="secondary" onClick={onCancel} size="sm">
              Cancel
            </Button>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-start pt-2">
          <span
            className="text-primary pointer d-flex align-items-center fw-semibold"
            onClick={onAddNew}
            style={{ cursor: "pointer", fontSize: "0.95rem" }}
          >
            <i className="fa-solid fa-plus me-2"></i>
            Add new
          </span>
        </div>
      )}
    </div>
    </>
  );
};

export default ManageMaterialItems;

